import { Outlet } from 'react-router-dom';

import App from '../App';
import AuthLayout from '../layout/auth.layout';
import Appsumo from '../pages/partnerAuth/Appsumo';
import BusinessInformation from '../pages/partnerAuth/BusinessInformation';
import BusinessLogin from '../pages/partnerAuth/BusinessLogin';
import BusinessRegister from '../pages/partnerAuth/BusinessRegister';
import Login from '../pages/partnerAuth/Login';
import Logout from '../pages/partnerAuth/Logout';
import Register from '../pages/partnerAuth/Register';
import ErrorPage from '../pages/site/ErrorPage';

const AppSumoAuthChildren = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'login',
        element: (
          <AuthLayout>
            <Login />
          </AuthLayout>
        ),
      },
      {
        path: 'register',
        element: (
          <AuthLayout>
            <Register />
          </AuthLayout>
        ),
      },
      {
        path: 'logout',
        element: <Logout />,
      },
    ],
  },
];

const AffiliateAuthChildren = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'login',
        element: (
          <AuthLayout>
            <BusinessLogin />
          </AuthLayout>
        ),
      },
      {
        path: 'information',
        element: <BusinessInformation />,
      },
      {
        path: 'register',
        element: <BusinessRegister />,
      },
      {
        path: 'logout',
        element: <Logout />,
      },
    ],
  },
];

const PartnerAuthRouter = [
  {
    path: '/en-US/partner/appsumo/',
    element: (
      <App>
        <Appsumo />
      </App>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/fr-FR/partner/appsumo/',
    element: (
      <App>
        <Appsumo />
      </App>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/en-US/partner/appsumo/',
    element: (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorPage />,
    children: AppSumoAuthChildren,
  },
  {
    path: '/fr-FR/partner/appsumo/',
    element: (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorPage />,
    children: AppSumoAuthChildren,
  },
  {
    path: '/en-US/partner/business/',
    element: (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorPage />,
    children: AffiliateAuthChildren,
  },
  {
    path: '/fr-FR/partner/business/',
    element: (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorPage />,
    children: AffiliateAuthChildren,
  },
];

export default PartnerAuthRouter;
